import React, { useEffect, useState } from "react";
import s from './ImageEditPage.module.scss'
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDropzone } from "react-dropzone"; // react-dropzoneをインポート
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { initializeApp } from "firebase/app";

const ImageEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchImages = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/api/admin/images/${id}`);
      setImages(response.data);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchImages();
  }, [id]);

  const handleUploadSuccess = () => {
    fetchImages();
  };

  if (isLoading) {
    return <p>読み込み中...</p>;
  }

  return (
    <div className={s.root}>
      <button onClick={() => navigate("/")} className={s.backButton}>
        ホームに戻る
      </button>
      <h1>画像編集</h1>
      {images.length > 0 &&  (
        <div>
          <div className={s.gallery}>
            {images.map((image, index) => (
              <img
                key={index}
                src={image.image_url}
                alt={`Image ${index}`}
                className={s.image}
              />
            ))}
          </div>
        </div>
      )}
      <div>
        <ImageUploadForm id={id} onUploadSuccess={handleUploadSuccess}/>
      </div>
    </div>
  );
};

const ImageUploadForm = ({ id, onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const firebaseConfig = {
    apiKey: "AIzaSyDwvU6jPInYlh3hJGuOqsB-1qEJi1NYmDw",
    authDomain: "maa-admin-1d479.firebaseapp.com",
    projectId: "maa-admin-1d479",
    storageBucket: "maa-admin-1d479.firebasestorage.app",
    messagingSenderId: "1035947988500",
    appId: "1:1035947988500:web:f493632599949384e5f901",
    measurementId: "G-R58CPKGQBQ"
  };

  const firebaseApp = initializeApp(firebaseConfig);
  const storage = getStorage(firebaseApp);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      const selectedFile = acceptedFiles[0];
      if (selectedFile) {
        setFile(selectedFile);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result);
        };
        reader.readAsDataURL(selectedFile);
      }
    },
  });


  const handleFileChange = (e) => {
    const selectedFile = e.target.files ? e.target.files[0] : null;
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError("画像を選択してください");
      return;
    }
    setLoading(true);
    setError(null);
    console.log('file', file)

    try {
      const storageRef = ref(storage, `images/${file.name}`);
      await uploadBytes(storageRef, file);
      const snapshot = await uploadBytes(storageRef, file);
      console.log("アップロードに成功しました", snapshot);

      const imageUrl = await getDownloadURL(storageRef);
      console.log("画像URL:", imageUrl);

      const formData = new FormData();
      if (imageUrl) {
        formData.append('image', imageUrl);
      }

      formData.append('tour_id', id);

      const response = await axios.post(`${apiUrl}/api/admin/create/image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 201) {
        onUploadSuccess();
      }
    } catch (uploadError) {
      console.error("画像のアップロードに失敗しました", uploadError);
      setError("画像のアップロードに失敗しました");
    } finally {
      setLoading(false);
      setPreview(null);
      setFile(null);
    }
  };
  return (
    <form onSubmit={handleSubmit} className={s.uploadForm}>
    <div {...getRootProps()} className={s.dropzone}>
    <input {...getInputProps()} />
    {preview ? (
      <img src={preview} alt="プレビュー" className={s.previewImage} />
    ) : (
      <p>画像をドラッグ＆ドロップまたはクリックして選択</p>
    )}
  </div>


    {loading && (
      <div className={s.preview}>
        <p>アップロード中...</p>
        <div className={s.loader}></div>
      </div>
    )}

    {error && <div className={s.error}>{error}</div>}

    <button type="submit" disabled={loading}>
      {loading ? "アップロード中..." : "アップロード"}
    </button>
  </form>
  );
};

export default ImageEditPage;
